module.exports = __webpack_public_path__ + "static/img/花瓶12.40e57da.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶12.png
// module id = Z/s1
// module chunks = 2